import React from "react";

export default function IconAdvantageStatement() {
  return (
    <svg
      viewBox="0 0 3645 1382"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon-advantage-statement"    
    >
      <g id="Group 3">
        <path
          id="Vector 2"
          opacity="0.66"
          d="M918.387 852.754C350.701 1272.68 375.104 7.85008 0.970703 2.00781L1.46052 1381.5L1835.69 1380.85C1835.69 1380.85 1738.4 637.359 1447.96 967.746C1157.53 1298.13 1486.07 432.833 918.387 852.754Z"
          fill="url(#paint0_linear_213_5)"
        ></path>
        <path
          id="Vector 3"
          opacity="0.66"
          d="M2740.12 851.985C3300.17 1271.76 3275.78 6.93948 3644.81 1L3644.68 1380.49L1835.45 1380.31C1835.45 1380.31 1931.22 636.803 2217.79 967.114C2504.35 1297.43 2180.06 432.211 2740.12 851.985Z"
          fill="url(#paint1_linear_213_5)"
        ></path>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_213_5"
          x1="1.28492"
          y1="886.929"
          x2="1835.51"
          y2="886.277"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#652AC6" stopOpacity="0.101961"></stop>
          <stop
            offset="0.533654"
            stopColor="#FF0000"
            stopOpacity="0.168627"
          ></stop>
          <stop offset="1" stopColor="#FF0000" stopOpacity="0.168627"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_213_5"
          x1="3644.73"
          y1="885.921"
          x2="1835.5"
          y2="885.746"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#652AC6" stopOpacity="0.101961"></stop>
          <stop
            offset="0.533654"
            stopColor="#FF0000"
            stopOpacity="0.168627"
          ></stop>
          <stop offset="1" stopColor="#FF0000" stopOpacity="0.168627"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}
